import { Link, useParams } from 'react-router-dom';

import { Button } from '../../catalyst/button';
import { Divider } from '../../catalyst/divider';
import { Heading, Subheading } from '../../catalyst/heading';


import { ChevronLeftIcon } from '@heroicons/react/16/solid';
import { format, parseISO } from 'date-fns';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorMessage, Field } from '../../catalyst/fieldset';
import ConfirmationModel from '../../components/ConfirmationModel';
import LoadingMain from '../../components/LoadingMain';
import config from '../../config';
import { getSyncStatusBadge } from '../../utils';
import EditSyncModel from './editSyncModel';
import { SyncRunsTable } from './syncRunsTable';

function Stat({ title, value }) {
  return (
    <div>
      <Divider />
      <div className="mt-6 text-lg/6 font-medium sm:text-sm/6"><Heading>{title}</Heading></div>
      <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8"><Heading>{value}</Heading></div>
    </div>
  )
}

export default  function ViewSync() {
  const navigate = useNavigate();

  const {syncId} = useParams()

  const [sync, setSync] = useState([])
  const [syncRuns, setSyncRuns] = useState([])

  const [loading, setLoading] = useState(true);
  const [errResponse, setErrResponse] = useState("")


  const [editSyncModelOpen, setEditSyncModelOpen] = useState(false)


  const [deleteSyncModelOpen, setDeleteSyncModelOpen] = useState(false)
  const [submittingDelete, setSubmittingDelete] = useState(false)
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("")



  useEffect(() => {
    const fetchData = async () => {
      try {
        setErrResponse("")
        setLoading(true); // Set loading state to true
        const response = await fetch(config.apiUrl + "/sync/"+syncId+"/runs", {
          headers: {
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
          }
        });

        const status = await response.status;
        if (status === 200) {
          let data = await response.json()
          setSync(data.sync)
          setSyncRuns(data.syncRuns)
        } else {
          throw new Error('Failed to get sync runs');
        }

      } catch (error) {
        setErrResponse("Failed to get sync runs. Please try again or contact us.")
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false); // Set loading state to false after fetch completes
      }
    };

    fetchData();
  }, []);



  function deleteSync () {
    setSubmittingDelete(true)
    setDeleteErrorMessage("")
    fetch(config.apiUrl + "/sync/"+sync.id, {
      method: 'DELETE',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
      }
  }).then(response => {
      if (!response.ok) {
          throw new Error('Failed to delete sync.');
      }
      return response;
  })
      .then(response => {
          setSubmittingDelete(false)
          setDeleteSyncModelOpen(false)
          navigate(config.syncPath)
      })
      .catch(error => {
          setSubmittingDelete(false)
          setDeleteErrorMessage("Failed to delete sync.")
      });
}


  function SyncRunDetails() {
    return (    
    <>
          <ConfirmationModel
            open={deleteSyncModelOpen}
            setIsOpen={(flag) => { setDeleteSyncModelOpen(flag) }}
            title={ "Delete " + sync.name}
            description={ "Do you want to Delete " + sync.name + " sync?"}
            buttonText={"Delete"}
            submitting={submittingDelete}
            confirmationAction={(flag) => { deleteSync() }}
            errResponse={deleteErrorMessage}
          ></ConfirmationModel>

        <EditSyncModel sync={sync} editSyncModelOpen={editSyncModelOpen} setEditSyncModelOpen={(flag) => setEditSyncModelOpen(flag)}></EditSyncModel>

      <div className="mt-4 flex flex-wrap items-end justify-between gap-4">
        <div className="flex flex-wrap items-center gap-6">
          <div className="w-32 shrink-0">
            <img className="aspect-3/2 rounded-lg shadow-sm" src={"https://picsum.photos/300/200?grayscale&id=" +sync.id } alt="" />
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
              <Heading>{sync.name}</Heading>
              {getSyncStatusBadge(sync)}
            </div>
            <div className="mt-2 text-sm/6 text-zinc-500">
              Create on {format(parseISO(sync.createdAt), "eeee, MMMM do, yyyy 'at' h:mm a")}
              
            </div>
          </div>
        </div>
        <div className="flex gap-4">
          <Button outline onClick={() =>setEditSyncModelOpen(true)}>Edit</Button>
          <Button color="red" onClick={() => {setDeleteErrorMessage(""); setDeleteSyncModelOpen(true)}}>Delete</Button>
        </div>
      </div>
      <div className="mt-8 grid gap-8 sm:grid-cols-3">
        <Stat 
        title="Total songs added"
          value={sync.totalAdded +"/" + sync.totalToAdd} />
        <Stat
          title="Tickets songs removed"
          value={sync.totalRemoved +"/" + sync.totalToRemove} />
        <Stat title="Total Runs" value={syncRuns.length}  />
      </div>
      <Subheading className="mt-12">Recent sync runs</Subheading>
      <SyncRunsTable syncRuns={syncRuns}></SyncRunsTable>

    </>
    )
  }

  return (
      <>
      
      <div className="">
        <Link to="/dashboard/sync" className="inline-flex items-center gap-2 text-sm/6 text-zinc-500 dark:text-zinc-400">
          <ChevronLeftIcon className="size-4 fill-zinc-400 dark:fill-zinc-500" />
            Syncs
        </Link>
      </div>
      
      {
        loading ? (<><LoadingMain/></>) : 
             errResponse ? 
             (<Field><ErrorMessage>{errResponse}</ErrorMessage></Field>) : 
                (<SyncRunDetails/>)
      }

      </>
  )
}
